import { buildValueMap } from "./utils";

export const SOStatusDef = {
    Created: { value: 1, label: "Created" },
    Issued: { value: 2, label: "Issued" },
    Picked: { value: 3, label: "Picked" },
    Partial: { value: 4, label: "Partial Fulfilled" },
    PartialFulfilledInvoiced: { value: 5, label: "Partial Fulfilled Invoiced" },
    ShortClosed: { value: 6, label: "Short Closed" },
    Fulfilled: { value: 7, label: "Fulfilled" },
    FulfilledPartiallyInvoiced: { value: 8, label: "Fulfilled Partially Invoiced" },
    FulfilledInvoiced: { value: 9, label: "Fulfilled Invoiced" },
    Voided: { value: 10, label: "Voided" },
    PartiallyInvoiced: { value: 11, label: "Partially Invoiced" },
    Invoiced: { value: 12, label: "Invoiced" }
};

export const SOPOStatusDef = {
    Open: { value: 1, label: "Open" },
    Voided: { value: 2, label: "Voided" },
    Fulfilled: { value: 3, label: "Fulfilled" }
};

export const FulfillmentStatusDef = {
    NotInvoiced: { value: 1, label: "Not Invoiced" },
    Invoiced: { value: 3, label: "Invoiced" },
    Voided: { value: 4, label: "Voided" }
};

export const InvoiceStatusDef = {
    Current: { value: 1, label: "Current" },
    Partial: { value: 2, label: "Partial" },
    PastDue: { value: 3, label: "Past Due" },
    PastDuePartial: { value: 4, label: "Past Due Partial" },
    Paid: { value: 5, label: "Paid" },
    Voided: { value: 6, label: "Voided" }
};

export const SOStatus = buildValueMap(SOStatusDef);
export const SOPOStatus = buildValueMap(SOPOStatusDef);
export const FulfillmentStatus = buildValueMap(FulfillmentStatusDef);
export const InvoiceStatus = buildValueMap(InvoiceStatusDef);
